import { ProfileDomainEnum, ProfileLinkCategoryEnum } from '~/src/models/enums/profile-link-category.enum';
import { isProduction } from '~/src/params';

export const getMainDomain = (linkCategory: ProfileLinkCategoryEnum): ProfileDomainEnum => {
    switch (linkCategory) {
        case ProfileLinkCategoryEnum.FINANCE_AND_PAYMENTS:
            return ProfileDomainEnum.FINANCE_AND_PAYMENTS;
        case ProfileLinkCategoryEnum.CONTRACTS:
            return ProfileDomainEnum.CONTRACTS;
        case ProfileLinkCategoryEnum.EMPLOYEES:
            return ProfileDomainEnum.EMPLOYEES;
        default:
            return ProfileDomainEnum.DEFAULT;
    }
};
export const createLink = (linkCategory: ProfileLinkCategoryEnum) => {
    const baseUrlProfileAgent = 'utm_campaign=agentsb2b&utm_medium=referral&utm_source=lk_agenta';
    const urlTest = `https://profile.pxp-stage.mts-corp.ru/${getMainDomain(
        linkCategory,
    )}${baseUrlProfileAgent}`;
    const urlProd = `https://profile.mts.ru/${getMainDomain(
        linkCategory,
    )}${baseUrlProfileAgent}`;
    return isProduction ? urlProd : urlTest;
};